// The UMD file falls through to its browser-globals branch under native ESM
// and assigns `window.I18n` itself, preserving any state Rails-side inline
// scripts already put on the global (locale, translations).
import "../../../vendor/assets/javascripts/i18n.js";
import { extend } from "lodash";

// Remove js. scope from all translations
for (const lang in window.I18n.translations) {
  const translations = window.I18n.translations[lang];
  window.I18n.translations[lang] = extend({}, translations, translations.js);
}
